import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/usr/app/src/app/providers/index.tsx");
